module.exports = __webpack_public_path__ + "media/images/shipped-d7a280854df8373b60fcb6762b594577.svg";